export default function getDateValue(dateRange) {
    if (Array.isArray(dateRange)) {
        return dateRange;
    }
    return [];
}
